import EventQrCodesTab from "./EventQrCodesTab"

/*
  The Event Videos library tab (EventVideosTab) is hidden for now. Its API and
  components are still in place; to bring it back, restore the tab bar that
  switched between EventQrCodesTab and EventVideosTab.
*/
const EventQrCodes = () => (
  // Exactly the window below the fixed navbar (the layout's mt-6 + pt-14 =
  // 80px), so the table can fill what's left and scroll only its rows.
  <div className="mx-4 flex h-[calc(100vh_-_80px)] flex-col pb-4 pt-4">
    <h1 className="mb-4 shrink-0 text-xl font-medium text-primary">
      Event QR Codes
    </h1>
    <EventQrCodesTab />
  </div>
)

export default EventQrCodes
